import { createBrowserHistory } from 'history';

import { LocationState } from 'src/types/routes.types';

export const history = createBrowserHistory<LocationState>();
